var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.562.03C7.65.437 4.22 2.566 2.138 5.881c-2.964 4.72-2.389 10.996 1.38 15.056 2.077 2.238 4.63 3.564 7.7 4.002.582.082 2.503.081 3.106-.002 3.043-.422 5.614-1.763 7.687-4.013 1.707-1.851 2.798-4.213 3.178-6.88.081-.575.081-2.507 0-3.082-.29-2.033-.933-3.762-2.002-5.377a11.806 11.806 0 0 0-1.542-1.881C19.691 1.726 17.278.508 14.495.096c-.6-.089-2.336-.128-2.933-.066zm4.733 3.972c.149 1.995 1.837 3.663 3.885 3.837l.354.03v1.507c0 .894-.019 1.518-.046 1.535-.066.04-.991-.053-1.45-.146a7.725 7.725 0 0 1-2.453-.997l-.305-.198v3.166c0 1.827-.022 3.354-.05 3.607a5.67 5.67 0 0 1-3.116 4.476c-1.676.835-3.727.764-5.318-.184-2.789-1.663-3.634-5.254-1.871-7.944.354-.54 1.037-1.237 1.542-1.573a6.453 6.453 0 0 1 1.758-.8c.37-.098.64-.132 1.197-.15.395-.014.774-.011.843.006l.125.031v3.093l-.156-.031c-.655-.131-1.181-.066-1.744.218-1.299.653-1.788 2.166-1.127 3.481.295.585.956 1.112 1.615 1.288.337.09.971.09 1.308 0 .649-.173 1.3-.692 1.608-1.279.317-.606.304-.294.304-7.15l.001-6.226h3.066l.03.403z",
    fill: "#FFD300"
  })));
};

export default SvgTiktok;